<template>
  <div>
    <PageAllow
      controller="Purchases"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <!-- 仓库供应商 -->
    <v-dialog v-model="selectStockDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("PurchasesDetail.create") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8">
          <v-container class="pb-8">
            <v-row
              class="pa-3"
              v-if="
                accountInfo &&
                accountInfo.version &&
                (accountInfo.version.stock_type == 2 ||
                  accountInfo.version.stock_type == 3)
              "
            >
              <span class="text-right subtitle-1">
                {{ $t("CRUD.chooseInfo", [$t("PurchasesDetail.stock")])
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherStock
                v-model="stockSelected"
                noLabel
                single-line
                dense
                hide-details
                class="d-inline mt-0"
                :types="[0]"
                :status="[1]"
                :stockIds="settings.self_purchase_stocks"
                :selfPurchaseFlg="settings.self_purchase_flg"
              />
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                mode == "new"
                  ? $t("CRUD.newCreated", [$t("PurchasesDetail.ObjectName")])
                  : $t("CRUD.info", [$t("PurchasesDetail.ObjectName")])
              }}
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="purchase.status | purchaseStatusColor"
                :text-color="purchase.status | purchaseStatusTextColor"
              >
                {{ purchase.status | purchaseStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="preview"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="
                    purchase = JSON.parse(purchaseBeforPreview);
                    preview = false;
                  "
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <v-btn
                  v-if="
                    isNew && $permission.permissionAllow('Purchases', 'add')
                  "
                  small
                  :disabled="!stock || !stock.id"
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("PurchasesDetail.actions.submit") }}
                </v-btn>
              </v-sheet>
              <PurchasesActions
                v-if="isView"
                :purchase="purchase"
                :showCancel="purchase.actions && purchase.actions.cancel"
                :showCheck="purchase.actions && purchase.actions.check"
                :showDelivery="purchase.actions && purchase.actions.delivery"
                @done="getPurchasesDetailsFromAPI()"
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 采购单号 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.purchase_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.purchase_code }}
                </v-card>
              </v-col>
              <!-- 创建时间 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.created")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.created | formatTime }}
                </v-card>
              </v-col>

              <!-- 仓库 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.stock")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stock ? stock.name : "" }}
                  <v-btn
                    v-if="
                      isNew &&
                      !preview &&
                      accountInfo &&
                      accountInfo.version &&
                      (accountInfo.version.stock_type == 2 ||
                        accountInfo.version.stock_type == 3)
                    "
                    small
                    dark
                    text
                    color="action"
                    class="mb-n2"
                    @click.stop="selectStockDialog = true"
                  >
                    <v-icon x-small class="pe-1">fas fa-cubes</v-icon>
                    {{ $t("CRUD.rechooseInfo", [$t("PurchasesDetail.stock")]) }}
                  </v-btn>
                </v-card>
              </v-col>
              <!-- 期望配送日期 -->
              <v-col cols="12" md="4" v-if="isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.expect_date") }}
                    <Required
                      :show="savable ? true : false"
                      :mode="savable ? 'new' : ''"
                    />
                    {{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    v-if="!preview"
                    class="my-n2"
                    v-model="purchase.hope_delivery_date"
                    type="date"
                    single-line
                    dense
                    hide-details
                    :disabled-before-today="savable"
                  />
                  <span v-else>
                    {{ purchase.hope_delivery_date | formatDate }}
                  </span>
                </v-card>
              </v-col>
              <!-- 采购单来源 -->
              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.origin_flg")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.origin_flg | originFlgsText }}
                  </span>
                </v-card>
              </v-col>
              <!-- 创建者 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.creater")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.creater_name }}
                  </span>
                </v-card>
              </v-col>
              <!-- 第三方单号 -->
              <v-col cols="12" :md="isNew ? 12 : 4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.purchase")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="purchase.ext_code"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ purchase.ext_code }}
                  </span>
                </v-card>
              </v-col>
              <!-- 收货人 -->
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_name
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 联系方式 -->
              <v-col
                cols="12"
                md="8"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_phone")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_phone
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 收货地址 -->
              <v-col
                cols="12"
                md="12"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_address")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_province +
                          purchase.delivery_info.receiver_city +
                          purchase.delivery_info.receiver_area +
                          purchase.delivery_info.receiver_address
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 备注 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="purchase.memo"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ purchase.memo }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card
                  class="pa-2 d-flex overflow-auto text-no-wrap"
                  outlined
                  tile
                >
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.attachments")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <!-- 上传图片集 -->
                  <span class="ml-4">
                    <v-card
                      height="160"
                      width="240"
                      v-if="album && album.length > 0"
                    >
                      <v-carousel
                        hide-delimiters
                        cycle
                        height="160"
                        width="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(album, i)"
                        >
                          <v-tooltip right v-if="savable && item">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="removeFromImages(i)"
                                v-if="isNew"
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span> {{ $t("Material.delImg") }}</span>
                          </v-tooltip>
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                    <v-file-input
                      ref="imgs_file"
                      v-show="savable"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgsRules"
                      v-model="imgs_file"
                    >
                    </v-file-input>
                  </span>
                </v-card>
              </v-col>
              <!-- 详情二维码 -->
              <v-col
                cols="12"
                sm="12"
                md="12"
                v-if="purchase && purchase.view_qrcode_url"
              >
                <v-card
                  class="pa-2 d-flex overflow-auto text-no-wrap"
                  outlined
                  tile
                >
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.view_qrcode_url")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="ml-4">
                    <v-card height="240" width="240">
                      <v-img
                        max-width="240"
                        :src="purchase.view_qrcode_url"
                        @click.stop="
                          $showFullscreenImages([purchase.view_qrcode_url])
                        "
                      >
                      </v-img>
                    </v-card>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 活动记录 -->
        <v-expansion-panel v-if="!isNew" multiple accordio>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="InfoTab" background-color="transparent">
              <v-tab
                @click.stop="
                  InfoTab = 0;
                  panels.indexOf(1) == -1 ? panels.push(1) : '';
                "
              >
                {{ $t("PurchasesDetail.activities.title") }}
              </v-tab>
              <v-tab
                @click.stop="
                  InfoTab = 1;
                  panels.indexOf(1) == -1 ? panels.push(1) : '';
                "
              >
                {{ $t("PurchasesDetail.activities.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="InfoTab">
              <!-- 活动记录 -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="activities_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <!-- 相关单据 -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="stockInsHeaders"
                    :items="stockIns"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.stock_name>
                      {{ purchase.stock.name }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        small
                        label
                        class="ms-4 mt-1"
                        :color="purchase.status | stockOrderINStatusColor"
                        :text-color="
                          purchase.status | stockOrderINStatusTextColor
                        "
                      >
                        {{ item.status | stockOrderINStatusText }}
                      </v-chip>
                    </template>
                    <template v-slot:item.created="{ item }">
                      {{ item.created | formatTime }}
                    </template>
                    <template v-slot:item.stock_order_code="{ item }">
                      {{ $t("PurchasesList.Fields.inCode")
                      }}{{ item.stock_order_code }}
                      <br />
                      {{ $t("PurchasesList.Fields.billTypePurchaseCode")
                      }}{{ item.bill ? item.bill.bill_code : "" }}
                    </template>
                    <template v-slot:item.finish_time="{ item }">
                      {{ item.finish_time | formatTime }}
                    </template>
                    <template v-slot:item.stockInsActions="{ item }">
                      <v-btn
                        small
                        dark
                        color="info"
                        class="px-2 me-2 mb-1"
                        :href="'/#/stock-orders-in/' + item.id"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("PurchasesList.actions.detail") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>

    <div class="px-4 pb-4">
      <v-card class="px-4">
        <!-- 新增采购单 -->
        <v-data-table
          id="from_materials_details_table"
          v-if="!preview"
          :headers="detailHeaders"
          :items="purchase_details"
          multi-sort
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("PurchasesDetail.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
              <span v-if="isView" class="py-0 subtitle-1 d-inline-block">
                {{ $t("PurchasesDetail.price_total") }}
                {{ $t("Global.colon") }}
                <span class="danger--text">
                  {{ $t("Global.money") }}
                  {{ purchase.quantity_price_total | formatMoney }}
                </span>
              </span>
              <v-btn
                color="primary"
                small
                dark
                class="px-2 me-2 mb-1 mx-1"
                v-if="mode == 'new'"
                @click="stockSupplierMaterialsDialog = true"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      purchase_details
                        ? [1, purchase_details.length, purchase_details.length]
                        : [0, 0, 0]
                    )
                  }}
                </span>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <!-- 缺货状态 -->
          <template v-slot:item.is_lack="{ item }">
            <v-chip
              small
              label
              :color="item.is_lack | isLackStatusColor"
              :text-color="item.is_lack | isLackStatusTextColor"
            >
              {{ item.is_lack | isLackStatusText }}
            </v-chip>
            <br />
            <span
              v-if="Number(item.purchase_qty) > 0"
              class="pt-n1 text-no-wrap caption orange--text darken-3"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("PurchasesDetail.replenishment") }}
            </span>
          </template>
          <!-- 采购值 -->
          <template v-slot:item.purchase_qty="{ item }">
            {{ item.purchase_qty | formatWithDotNoMoreThan }}
          </template>
          <!-- 库存值  -->
          <template v-slot:item.current_count="{ item }">
            {{ item.current_count }}
            {{ item.default_unit }}
          </template>
          <!-- 采购订货数 -->
          <template v-slot:item.quantity="{ item }">
            <span v-if="savable">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.quantity"
                type="number"
                min="0"
                @blur="
                  item.quantity = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.quantity),
                    2
                  );
                  figureUpDefaultQuantity(item);
                "
                style="max-width: 100px; margin-left: auto"
              >
                <template v-if="!locale" v-slot:append>
                  <span>
                    {{ item.new ? item.purchase_unit : item.unit }}
                  </span>
                </template>
              </v-text-field>
              <span v-if="locale" class="pt-n1 text-no-wrap caption">
                {{ item.new ? item.purchase_unit : item.unit }}
              </span>
              <span
                v-if="item.supplier"
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.bind_supplier_memo }}
              </span>
            </span>
            <span v-else>
              {{ item.quantity | formatTwoDot }}
              <br v-if="locale" />
              <span v-if="locale" class="pt-n1 text-no-wrap caption">
                {{ item.new ? item.purchase_unit : item.unit }}
              </span>
              <span v-else>
                {{ item.new ? item.purchase_unit : item.unit }}
              </span>
            </span>
          </template>
          <!-- 基准 -->
          <template v-slot:item.default_quantity="{ item }">
            <span v-if="savable">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.default_quantity"
                type="number"
                min="0"
                @blur="
                  item.default_quantity =
                    $numberFormatter.formatWithDotNoMoreThan(
                      Number(item.default_quantity),
                      2
                    );
                  figureUpQuantity(item);
                "
                style="max-width: 100px; margin-left: auto"
              >
                <template v-if="!locale" v-slot:append>
                  <span>
                    {{ item.default_unit }}
                  </span>
                </template>
              </v-text-field>
              <span v-if="locale" class="pt-n1 text-no-wrap caption">
                {{ item.default_unit }}
              </span>
            </span>
            <span v-else>
              {{ item.default_quantity | formatTwoDot }}
              <br v-if="locale" />
              <span v-if="locale" class="pt-n1 text-no-wrap caption">
                {{ item.default_unit }}
              </span>
              <span v-else>
                {{ item.default_unit }}
              </span>
            </span>
          </template>

          <!-- 单价 -->
          <template v-slot:item.price="{ item }">
            <span v-if="item.negotiate_price_flg == 1">
              {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
            </span>
            <span
              v-else-if="
                item.supplier && item.supplier.material_negotiate_price_flg == 1
              "
            >
              {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
            </span>
            <span v-else>
              <v-text-field
                v-if="savable && settings && settings.purchase_subtotal != 1"
                v-model="item.price"
                :placeholder="
                  String($numberFormatter.formatTwoDot(item.price, 2))
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.price),
                    2
                  );
                  updateItemTotalPrice(item);
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span v-else>
                {{ $t("Global.money") }}{{ item.price | formatMoney }}
              </span>
            </span>
          </template>
          <!-- 小记 -->
          <template v-slot:item.total="{ item }">
            <span v-if="item.negotiate_price_flg == 1">
              {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
            </span>
            <span
              v-else-if="
                item.supplier && item.supplier.material_negotiate_price_flg == 1
              "
            >
              {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
            </span>
            <span v-else>
              <v-text-field
                v-if="savable && settings && settings.purchase_subtotal == 1"
                v-model="item.total"
                :placeholder="
                  String($numberFormatter.formatTwoDot(item.total, 2))
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.total = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.total),
                    2
                  );
                  updateItemTotalPrice(item);
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span v-else>
                {{ $t("Global.money") }}
                {{ item.total | formatMoney }}
              </span>
            </span>
          </template>
          <!-- 备注 -->
          <template v-slot:item.memo="{ item }">
            <v-text-field
              v-if="savable"
              v-model="item.memo"
              single-line
              dense
              hide-details
              style="max-width: 120px"
            >
              <template v-slot:append>
                <v-icon
                  x-small
                  @click.stop="
                    detail_memo_item = item;
                    memoDialog = true;
                  "
                  class="pt-2 pb-1 primary--text"
                >
                  fa-edit
                </v-icon>
              </template>
            </v-text-field>
            <span v-else>
              {{ item.memo }}
            </span>
          </template>
          <!-- 操作 -->
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="savable"
              small
              text
              class="danger--text pa-0"
              @click.stop="
                purchase_details.splice(
                  purchase_details.findIndex((e) =>
                    item.new
                      ? item.new == e.new
                      : item.material_id == e.material_id
                  ),
                  1
                )
              "
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </template>
          <template v-slot:footer>
            <v-row
              v-if="mode == 'new'"
              no-gutters
              align="center"
              class="ps-1 text-no-wrap d-flex"
            >
              <span class="secondary--text">
                {{ $t("CRUD.newInfo", [$t("Material.ObjectName")])
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherStockSupplierMaterial
                v-if="mode == 'new'"
                v-model="addMaterial"
                :stock-id="purchase.stock_id"
                :supplier-id="purchase.supplier_id"
                no-label
                :disabled-items="
                  purchase_details
                    ? purchase_details.map((detail) => {
                        return { material_id: detail.material_id };
                      })
                    : []
                "
              />
            </v-row>
          </template>
        </v-data-table>
        <!-- 新增预览 -->
        <div v-if="preview" class="pb-2">
          <v-card-title>
            {{ $t("CRUD.info", [$t("PurchasesDetail.detailName")]) }}
          </v-card-title>
          <v-divider />
          <v-card
            v-for="(purchase, key) in purchasesPreview"
            :key="key"
            class="ma-2"
          >
            <v-card-title>
              {{ $t("PurchasesDetail.ObjectName") }}{{ key + 1 }}
            </v-card-title>
            <v-card-subtitle>
              {{ purchase.supplier.supplier_name }}
            </v-card-subtitle>
            <v-data-table
              :headers="previewHeaders"
              :items="purchase.purchase_details"
              multi-sort
              disable-pagination
              hide-default-footer
              class="mb-2"
            >
              <!-- 采购订货数 -->
              <template v-slot:item.quantity="{ item }">
                {{ item.quantity | formatTwoDot }}
                <br v-if="locale" />
                <span v-if="locale" class="pt-n1 text-no-wrap caption">
                  {{ item.purchase_unit }}
                </span>
                <span v-else>
                  {{ item.purchase_unit }}
                </span>
              </template>
              <!-- 基准 -->
              <template v-slot:item.default_quantity="{ item }">
                <span v-if="!preview && isNew && item.new">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="item.default_quantity"
                    type="number"
                    min="0"
                    @blur="figureUpQuantity(item)"
                    style="max-width: 100px; margin-left: auto"
                  >
                    <template v-if="!locale" v-slot:append>
                      <span>
                        {{ item.default_unit }}
                      </span>
                    </template>
                  </v-text-field>
                  <span v-if="locale" class="pt-n1 text-no-wrap caption">
                    {{ item.default_unit }}
                  </span>
                </span>
                <span v-else>
                  {{ item.default_quantity | formatTwoDot }}
                  <br v-if="locale" />
                  <span v-if="locale" class="pt-n1 text-no-wrap caption">
                    {{ item.default_unit }}
                  </span>
                  <span v-else>
                    {{ item.default_unit }}
                  </span>
                </span>
              </template>
              <!-- 单价 -->
              <template v-slot:item.price="{ item }">
                <span v-if="item.negotiate_price_flg == 1">
                  {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
                </span>
                <span v-else>
                  {{ $t("Global.money") }}{{ item.price | formatMoney }}
                </span>
              </template>
              <!-- 小记 -->
              <template v-slot:item.total="{ item }">
                <span v-if="item.negotiate_price_flg == 1">
                  {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
                </span>
                <span v-else>
                  {{ $t("Global.money") }}{{ item.total | formatMoney }}
                </span>
              </template>
              <!-- 备注 -->
              <template v-slot:item.memo="{ item }">
                <v-text-field
                  v-if="savable"
                  v-model="item.memo"
                  single-line
                  dense
                  hide-details
                  style="max-width: 120px"
                >
                  <template v-slot:append>
                    <v-icon
                      x-small
                      @click.stop="
                        detail_memo_item = item;
                        memoDialog = true;
                      "
                      class="pt-2 pb-1 primary--text"
                    >
                      fa-edit
                    </v-icon>
                  </template>
                </v-text-field>
                <span v-else>
                  {{ item.memo }}
                </span>
              </template>
              <template v-slot:footer>
                <v-divider v-if="!savable" />
                <v-row no-gutters v-if="!savable">
                  <v-spacer />
                  <v-col cols="12" sm="6" md="3">
                    <v-list-item>
                      <v-list-item-content>
                        <span class="secondary--text font-weight-bold">
                          {{ $t("PurchasesDetail.purchaseFields.total") }}
                        </span>
                      </v-list-item-content>
                      <v-list-item-content class="align-end text-end">
                        <span class="accent--text font-weight-bold">
                          {{ $t("Global.money")
                          }}{{ purchase.total_price | formatMoney }}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-card>
    </div>

    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('PurchasesDetail.Fields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <StockSupplierMaterialDialog
      v-model="stockSupplierMaterialsDialog"
      :stock-id="purchase.stock_id"
      :supplier-id="purchase.supplier_id"
      :disabled-items="purchase_details ? purchase_details : []"
      @confirm="selectMaterials = $event"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherStockSupplierMaterial from "@/components/plugins/SearcherStockSupplierMaterial";
import Required from "@/components/plugins/Required";
import Purchases from "@/api/purchases.js";
import Stocks from "@/api/stocks";
import Suppliers from "@/api/suppliers";
import SupplierMaterials from "@/api/supplier_materials";
import StockSupplierMaterialDialog from "./plugins/StockSupplierMaterialDialog";
import Files from "@/api/files";
import PurchasesActions from "./plugins/Actions";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    SearcherStock,
    SearcherStockSupplierMaterial,
    Required,
    StockSupplierMaterialDialog,
    PurchasesActions,
  },
  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.purchasesList"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: this.isNew
            ? i18n.t("Nav.purchasesNew")
            : i18n.t("Nav.purchasesDetail"),
          disabled: true,
        },
      ];
      if (this.purchase && this.purchase.purchase_code) {
        items.push({
          text: this.purchase.purchase_code,
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    locale() {
      return this.$i18n.locale != "zhHans";
    },
    useTaxOne() {
      return this.settings && this.settings.use_tax == 1;
    },
    useTaxZero() {
      return this.settings && this.settings.use_tax == 0;
    },
    isNew() {
      return this.mode == "new";
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return !this.preview && this.mode == "new";
    },
    quantityAdd() {
      var sum = 0;
      for (var i in this.purchase_details) {
        sum += parseFloat(this.purchase_details[i].quantity);
      }
      return sum;
    },
    defaultQuantityAdd() {
      var sum = 0;
      for (var i in this.purchase_details) {
        sum += parseFloat(this.purchase_details[i].default_quantity);
      }
      return sum;
    },
    beforeTaxTotalAdd() {
      var sum = 0;
      for (var i in this.purchase_details) {
        sum += parseFloat(this.purchase_details[i].before_tax_total);
      }
      return sum;
    },
    afterTaxTotalAdd() {
      var sum = 0;
      for (var i in this.purchase_details) {
        sum += parseFloat(this.purchase_details[i].after_tax_total);
      }
      return sum;
    },
    priceAdd() {
      var sum = 0;
      for (var i in this.purchase_details) {
        sum += parseFloat(this.purchase_details[i].total);
      }
      return sum;
    },
    detailHeaders() {
      var headers = [
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
      ];

      if (
        this.preview ||
        this.mode == "new" ||
        (this.savable && !this.isNew) ||
        this.isView
      ) {
        headers.push({
          text: i18n.t("PurchasesDetail.purchaseFields.supply_code"),
          align: "start",
          sortable: false,
          value: "supply_code",
        });
      }

      if (!this.preview && this.isNew) {
        headers.push({
          text: i18n.t("PurchasesDetail.purchaseFields.stockout_status"),
          align: "start",
          sortable: false,
          value: "is_lack",
        });
      }

      if ((this.savable && !this.isNew) || this.isView) {
        headers.push({
          text: i18n.t("PurchasesDetail.purchaseFields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        });
      }

      if (this.isNew) {
        headers.push(
          // 采购值
          {
            text: i18n.t("PurchasesDetail.purchaseFields.purchase_value"),
            align: "end",
            sortable: false,
            value: "purchase_qty",
          }
        );
        if (
          this.accountInfo &&
          this.accountInfo.version &&
          (this.accountInfo.version.stock_type == 2 ||
            this.accountInfo.version.stock_type == 3)
        ) {
          headers.push(
            // 库存值
            {
              text: i18n.t("PurchasesDetail.purchaseFields.current_count"),
              align: "end",
              sortable: false,
              value: "current_count",
            }
          );
        }
      }

      if (this.settings && this.settings.use_tax == 1 && this.isView) {
        headers.push(
          //商品税率
          {
            text: i18n.t("PurchasesDetail.purchaseFields.tax_rate"),
            align: "end",
            sortable: false,
            value: "tax_rate",
          },
          //     单价 不含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.before_tax_price"),
            align: "end",
            sortable: false,
            value: "before_tax_price",
          },
          //   单价 含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.after_tax_price"),
            align: "end",
            sortable: false,
            value: "after_tax_price",
          }
        );
      } else if (this.settings && this.settings.use_tax == 0 && this.isView) {
        headers.push(
          //   单价
          {
            text: i18n.t("PurchasesDetail.purchaseFields.price"),
            align: "end",
            sortable: false,
            value: "price",
          }
        );
      }

      headers.push(
        //   采购订货数
        {
          text: i18n.t("PurchasesDetail.purchaseFields.quantity"),
          align: "center",
          sortable: false,
          value: "quantity",
        },
        //   基准订货数
        {
          text: i18n.t("PurchasesDetail.purchaseFields.default_quantity"),
          align: "end",
          sortable: false,
          value: "default_quantity",
        }
      );

      if (this.settings && this.settings.use_tax == 1 && this.isView) {
        headers.push(
          //   采购金额 不含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.before_tax_total"),
            align: "end",
            sortable: false,
            value: "before_tax_total",
          },
          //   采购金额 含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.after_tax_total"),
            align: "end",
            sortable: false,
            value: "after_tax_total",
          }
        );
      } else if (this.settings && this.settings.use_tax == 0 && this.isView) {
        headers.push(
          // 采购金额
          {
            text: i18n.t("PurchasesDetail.purchaseFields.total"),
            align: "end",
            sortable: false,
            value: "total",
          }
        );
      }

      if (this.savable || this.preview) {
        headers.push(
          // 单价
          {
            text: i18n.t("PurchasesDetail.purchaseFields.price"),
            align: "end",
            sortable: false,
            value: "price",
          },
          // 小记
          {
            text: i18n.t("PurchasesDetail.purchaseFields.sum"),
            align: "end",
            sortable: false,
            value: "total",
            width: "120",
          },
          {
            text: i18n.t("PurchasesDetail.purchaseFields.memo"),
            align: "start",
            sortable: false,
            value: "memo",
            width: "80",
          }
        );
      }

      if (this.savable && !this.preview) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      if (this.isView) {
        headers.push({
          text: i18n.t("PurchasesDetail.purchaseFields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        });
      }

      return headers;
    },
    previewHeaders() {
      var headers = [
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard.name",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.supply_code"),
          align: "start",
          sortable: false,
          value: "supply_code",
        },
        //   采购订货数
        {
          text: i18n.t("PurchasesDetail.purchaseFields.quantity"),
          align: "center",
          sortable: false,
          value: "quantity",
        },
        //   基准订货数
        {
          text: i18n.t("PurchasesDetail.purchaseFields.default_quantity"),
          align: "end",
          sortable: false,
          value: "default_quantity",
        },
        // 单价
        {
          text: i18n.t("PurchasesDetail.purchaseFields.price"),
          align: "end",
          sortable: false,
          value: "price",
        },
        // 小记
        {
          text: i18n.t("PurchasesDetail.purchaseFields.sum"),
          align: "end",
          sortable: false,
          value: "total",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        },
      ];

      return headers;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("PurchasesDetail.activities.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("PurchasesDetail.activities.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("PurchasesDetail.activities.operater"),
        align: "start",
        sortable: false,
        value: "operater.name",
      },
    ],
    stockInsHeaders: () => [
      {
        text: i18n.t("PurchasesDetail.stockIns.stock_order_code"),
        align: "start",
        sortable: false,
        value: "stock_order_code",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.stock_name"),
        align: "start",
        sortable: false,
        value: "stock_name",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.created"),
        align: "center",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.finish_time"),
        align: "center",
        sortable: false,
        value: "finish_time",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "stockInsActions",
      },
    ],

    ...mapState(["settings", "accountUser", "accountInfo"]),
  },

  data: () => ({
    stock: {},
    supplier: {},
    stockSelected: null,
    selectStockDialog: false,
    panels: [0],
    panelsDetail: [0],
    InfoTab: null,
    DetailTab: null,
    mode: "",
    purchase: {},
    examinesDetails: [],
    purchase_details: [],
    activities_details: [],
    stockIns: [],
    addMaterial: null,
    detail_memo_item: { memo: "" },
    memoDialog: false,
    purchasesPreview: [],
    preview: false,
    purchaseBeforPreview: [],
    selectMaterials: [],
    stockSupplierMaterialsDialog: false,
    album: [],
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    purchase_img: [],
  }),

  mounted() {
    if (this.$route.path.startsWith("/purchases/new")) {
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode)
        this.$router.replace("/purchases/detail/" + this.$route.params.id);
    }
  },

  methods: {
    getStockFromAPI(stock_id) {
      Stocks.fetchOne(stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
    },
    getPurchasesDetailsFromAPI() {
      Purchases.fetchOne(this.$route.params.id, {
        order_activity: 1,
        purchase_code: this.$route.query.code,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchase = response.data.purchase;
            this.purchase_details = response.data.purchase.purchase_details.map(
              (detail) => {
                detail.quantity = this.$numberFormatter.formatWithDotNoMoreThan(
                  Number(detail.quantity),
                  2
                );
                detail.default_quantity =
                  this.$numberFormatter.formatWithDotNoMoreThan(
                    Number(detail.default_quantity),
                    2
                  );
                detail.price = this.$numberFormatter.formatWithDotNoMoreThan(
                  Number(detail.price),
                  2
                );
                return detail;
              }
            );
            this.examinesDetails = response.data.purchase.stock_in_order_detail;
            this.activities_details = response.data.order_activities;
            this.stockIns = response.data.stock_ins;
            this.stock = response.data.purchase.stock;
            this.supplier = response.data.purchase.supplier;
            this.album = response.data.purchase.img;
          }
        }.bind(this)
      );
    },
    //根据商品采购
    addFromMaterialsDetail(material_ids) {
      SupplierMaterials.fetchProduct({
        stock_id: this.stock.id,
        material_ids: material_ids,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            var materials = response.data.materials;
            materials.forEach((material) => {
              var purchase_detail = {
                new: this.purchase_details.length + 1,
                material_id: material.id,
                material_code: material.material_code,
                material_name: material.material_name,
                current_count: material.stock_material.current_count,
                is_lack: material.stock_material.is_lack,
                memo: null,
                default_unit: material.standard.default_standard_detail.unit,
                suppliers: material.suppliers,
                purchase_qty: material.stock_material.purchase_qty,
                default_standard_id:
                  material.standard.default_standard_detail.id,
                standard_details: material.standard.standard_details,
              };
              if (this.mode == "new") {
                let supplier = material.suppliers.find(
                  (supplier) =>
                    supplier.id == this.supplier.id ||
                    supplier.id == this.purchase.supplier_id
                );

                purchase_detail = Object.assign({}, purchase_detail, {
                  supplier: supplier,
                  supply_code: supplier.supply_code,
                  bind_supplier_memo: supplier ? supplier.memo : "",
                  purchase_unit: supplier.purchase_unit,
                  purchase_standard_detail_id:
                    supplier.purchase_standard_detail_id,
                  standard_name: material.standard.name,
                  price: supplier.supplier_price,
                  negotiate_price_flg: supplier.material_negotiate_price_flg,
                });
              }
              purchase_detail = Object.assign({}, purchase_detail, {
                quantity: "",
                default_quantity: this.$route.query.material_ids
                  ? this.$numberFormatter.formatWithDotNoMoreThan(
                      Number(material.short_num),
                      2
                    )
                  : "",
              });
              if (purchase_detail.default_quantity) {
                this.figureUpQuantity(purchase_detail);
              }
              this.purchase_details.push(purchase_detail);
            });
          }
        }.bind(this)
      );
    },
    //根据每个商品所选的供应商获取采购单位和单价
    updateItem(bind_supplier, material) {
      if (material.new) {
        material.price = bind_supplier ? bind_supplier.supplier_price : 0;
        material.supply_code = bind_supplier ? bind_supplier.supply_code : "";
        material.purchase_unit = bind_supplier
          ? bind_supplier.purchase_unit
          : "";
        material.purchase_standard_detail_id = bind_supplier
          ? bind_supplier.purchase_standard_detail_id
          : "";
        material.bind_supplier_memo = bind_supplier ? bind_supplier.memo : "";
        material.total = this.$numberFormatter.formatMoney(
          Number(material.quantity) * Number(material.price)
        );
        //采购数量和基准单位数量联动
        if (
          Number(material.quantity) > 0 ||
          Number(material.default_quantity) > 0
        ) {
          let purchase_standar_detail = material.standard_details.find(
            (s) => s.id == material.purchase_standard_detail_id
          );
          if (Number(purchase_standar_detail.rate) > 1) {
            if (Number(material.quantity))
              material.default_quantity =
                Number(material.quantity) *
                Number(purchase_standar_detail.rate);
            else if (Number(material.default_quantity)) {
              if (
                Number(material.default_quantity) %
                Number(purchase_standar_detail.rate)
              ) {
                material.quantity = Number(
                  this.$numberFormatter.formatTwoDot(
                    Number(material.default_quantity) /
                      Number(purchase_standar_detail.rate)
                  )
                );
              } else {
                material.quantity =
                  Number(material.default_quantity) /
                  Number(purchase_standar_detail.rate);
              }
            }
          } else {
            if (Number(material.quantity))
              material.default_quantity = material.quantity;
            else if (Number(material.default_quantity))
              material.quantity = material.default_quantity;
          }

          //计算小计金额
          // if (this.settings.purchase_subtotal == 1) {
          //   if (material.quantity != 0) {
          //     material.price =
          //       Number(material.total) / Number(material.quantity);
          //   } else {
          //     material.price = 0;
          //   }
          // } else {
          //   material.total = Number(material.quantity) * Number(material.price);
          // }
        }
      }
    },
    figureUpDefaultQuantity(material) {
      if (material.supplier) {
        let purchase_standar_detail = material.standard_details.find(
          (s) => s.id == material.purchase_standard_detail_id
        );
        material.default_quantity =
          Number(material.quantity) * Number(purchase_standar_detail.rate);

        //计算小计金额
        if (this.settings.purchase_subtotal == 1) {
          if (material.quantity != 0) {
            material.price = Number(material.total) / Number(material.quantity);
          } else {
            material.price = 0;
          }
        } else {
          material.total = Number(material.quantity) * Number(material.price);
        }
      } else if (!this.isNew) {
        material.default_quantity =
          Number(material.quantity) * Number(material.rate);

        //计算小计金额
        if (this.settings.purchase_subtotal == 1) {
          if (material.quantity != 0) {
            material.price = Number(material.total) / Number(material.quantity);
          } else {
            material.price = 0;
          }
        } else {
          material.total = Number(material.quantity) * Number(material.price);
        }
      }
    },
    figureUpQuantity(material) {
      if (material.supplier) {
        let purchase_standar_detail = material.standard_details.find(
          (s) => s.id == material.purchase_standard_detail_id
        );
        if (purchase_standar_detail && purchase_standar_detail.rate) {
          if (
            Number(material.default_quantity) %
            Number(purchase_standar_detail.rate)
          ) {
            material.quantity = Number(
              this.$numberFormatter.formatTwoDot(
                Number(material.default_quantity) /
                  Number(purchase_standar_detail.rate)
              )
            );
          } else {
            material.quantity =
              Number(material.default_quantity) /
              Number(purchase_standar_detail.rate);
          }
          //计算小计金额
          if (this.settings.purchase_subtotal == 1) {
            if (material.quantity != 0) {
              material.price =
                Number(material.total) / Number(material.quantity);
            } else {
              material.price = 0;
            }
          } else {
            material.total = Number(material.quantity) * Number(material.price);
          }
        }
      } else if (!this.isNew) {
        if (Number(material.default_quantity) % Number(material.rate)) {
          material.quantity = Number(
            this.$numberFormatter.formatTwoDot(
              Number(material.default_quantity) / Number(material.rate)
            )
          );
        } else {
          material.quantity =
            Number(material.default_quantity) / Number(material.rate);
        }

        //计算小计金额
        if (this.settings.purchase_subtotal == 1) {
          if (material.quantity != 0) {
            material.price = Number(material.total) / Number(material.quantity);
          } else {
            material.price = 0;
          }
        } else {
          material.total = Number(material.quantity) * Number(material.price);
        }
      }
    },
    updateItemTotalPrice(material) {
      // 计算小计金额
      if (this.settings.purchase_subtotal == 1) {
        if (material.quantity != 0) {
          material.price = Number(material.total) / Number(material.quantity);
        } else {
          material.price = 0;
        }
      } else {
        material.total = Number(material.quantity) * Number(material.price);
      }
    },

    //整理预览提交数据
    doPreviewData() {
      let purchase = {
        stock_id: this.stock.id,
        hope_delivery_date: this.purchase.hope_delivery_date,
        memo: this.purchase.memo,
        ext_code: this.purchase.ext_code,
        purchase_details: [],
        origin_flg: 104,
      };

      this.purchase_details.forEach((detail) => {
        purchase.purchase_details.push({
          material_code: detail.material_code,
          supplier_id: detail.supplier.id,
          quantity: detail.quantity,
          price: detail.price,
          memo: detail.memo,
          total: detail.total,
        });
      });
      return purchase;
    },
    //添加预览
    doPreview() {
      if (!this.purchase.hope_delivery_date) {
        this.$snackbar.error(
          i18n.t("PurchasesDetail.Messages.expectDistributionDateNull")
        );
      } else {
        if (this.isNew) {
          this.purchaseBeforPreview = JSON.stringify(this.purchase);
          Purchases.addPreview(this.doPreviewData()).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.preview = true;
                this.purchasesPreview = response.data.purchases;
              }
            }.bind(this)
          );
        }
      }
    },
    //整理预览提交数据
    doSubmitData() {
      let oldPurchase = JSON.parse(this.purchaseBeforPreview);
      let purchases = [];
      this.purchasesPreview.forEach((detail) => {
        let purchase = {
          stock_id: detail.stock_id,
          hope_delivery_date: oldPurchase.hope_delivery_date,
          memo: oldPurchase.memo ? oldPurchase.memo : "",
          ext_code: oldPurchase.ext_code ? oldPurchase.ext_code : "",
          supplier_id: detail.supplier_id,
          purchase_details: [],
          origin_flg: 104,
        };
        if (this.isNew) {
          Object.assign(purchase, { img: this.purchase_img });
        }
        detail.purchase_details.forEach((purchase_detail) => {
          purchase.purchase_details.push({
            material_code: purchase_detail.material_code,
            price: purchase_detail.price,
            quantity: purchase_detail.quantity,
            memo: purchase_detail.memo,
            total: purchase_detail.total,
          });
        });
        purchases.push(purchase);
      });
      return purchases;
    },
    submitMethod() {
      if (this.isNew) return Purchases.add(this.doSubmitData());
    },
    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.isNew) {
        if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        this.purchase_img = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.imagesUpload(
            this.imgs_file,
            false,
            "images"
          );
          if (response.data.status.isOK()) {
            response.data.data.forEach((img) =>
              this.purchase_img.push(img.img_name)
            );
          }
        }
      }
      if (!this.isNew) {
        this.submitUploadImg();
        this.purchase_details = this.purchase_details.map((d) => {
          return Object.assign({}, d, {
            prices: d.price,
          });
        });
        this.purchase.purchase_details = JSON.parse(
          JSON.stringify(this.purchase_details)
        );
      }
      this.submitMethod()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/purchases");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },

    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      var purchase_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.imagesUpload(
          this.imgs_file,
          false,
          "images"
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => purchase_img.push(img.img_name));
          Purchases.update({
            purchase_code: this.purchase.purchase_code,
            img: purchase_img,
          })
            .then(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        }
      }
    },
  },

  watch: {
    $route(to) {
      this.selectStockDialog = false;
      if (to.path.startsWith("/purchases/new")) {
        this.mode = "new";
        this.panels = [0];
        this.panelsDetail = [0];
        this.InfoTab = null;
        this.DetailTab = null;
        this.stockSelected = null;
        this.purchase = {};
        this.stock = {};
        this.supplier = {};
        this.addMaterial = null;
        this.purchase_details = [];
      } else if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/purchases/detail/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.isNew) {
          this.purchase = {
            created_id: this.accountUser ? this.accountUser.id : "",
            creater_name: this.accountUser ? this.accountUser.name : "",
            hope_delivery_date: this.$datetimeUtils.formatTime(
              new Date(new Date().getTime() + 24 * 3600 * 1000)
            ),
            purchase_details: [],
            // supplier_id: this.accountUser.supplier.id,
          };

          if (
            !this.$route.query.stock_id &&
            this.accountInfo &&
            this.accountInfo.version &&
            (this.accountInfo.version.stock_type == 2 ||
              this.accountInfo.version.stock_type == 3)
          ) {
            //单仓和多仓自动弹出选择仓库窗口
            this.selectStockDialog = true;
          } else {
            //无仓版获取仓库
            Stocks.fetchAllForSelect().then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.stock = response.data.stocks[0];
                }
              }.bind(this)
            );
            if (!this.$route.query.stock_id && this.mode == "new") {
              //向供应商采购自动弹出选择窗口
              this.selectStockDialog = true;
            }
          }
        } else if (this.$route.params.id) {
          this.getPurchasesDetailsFromAPI();
        }
      },
    },
    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.id) {
          this.addFromMaterialsDetail([this.addMaterial.material_id]);
          //消除显示
          this.addMaterial = {
            id: 0,
            material_code: "",
            material_name: "",
            standard_name: "",
          };
        }
      },
    },
    selectMaterials: {
      handler() {
        if (this.selectMaterials && this.selectMaterials.length) {
          this.addFromMaterialsDetail(
            this.selectMaterials.map(
              (selectMaterial) => selectMaterial.material_id
            )
          );
        }
      },
    },
    stockSelected: {
      deep: true,
      handler() {
        if (this.stockSelected) {
          if (this.mode == "new" && this.selectStockDialog) {
            this.selectStockDialog = false;
          }
          this.getStockFromAPI(this.stockSelected.id);

          Suppliers.fetchOne(this.accountUser.supplier.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.supplier = response.data.supplier;
                this.purchase = Object.assign({}, this.purchase, {
                  supplier_id: this.accountUser.supplier.id,
                });
              }
            }.bind(this)
          );
        }
      },
    },
    stock: {
      handler() {
        if (this.stock) {
          this.purchase = Object.assign({}, this.purchase, {
            stock_id: this.stock.id,
          });
          if (this.$route.query.material_ids) {
            var material_ids = decodeURI(this.$route.query.material_ids).split(
              ","
            );
            this.addFromMaterialsDetail(material_ids);
          }
        }
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.purchase.img ? this.purchase.img : [];
        }
      },
    },
  },
};
</script>